export enum ErrorType {
  token = 'Token Error',
}
